<template>
    <li class="">
        <div
            :class="{bold: isFolder}"
            @click="toggle">
            <i v-if="isFolder" class="ml-1 fa " :class="(isOpen) ? 'fa-folder-open' : 'fa-folder'" role="presentation"></i>
            {{ item.name }}
        </div>
        <ul v-show="isOpen" v-if="isFolder" class="jstree-container-ul jstree-children">
            <tree-item
                class="item"
                v-for="(child, index) in item.children"
                :key="index"
                :item="child"
                @make-folder="$emit('make-folder', $event)"
                @add-item="$emit('add-item', $event)"
                ></tree-item>
        </ul>
    </li>
</template>

<script>
export default {
    props: {
        item: Object
    },
    data: function() {
        return {
        isOpen: false
        };
    },
    computed: {
        isFolder: function() {
            return this.item.children && this.item.children.length;
        }
    },
    methods: {
        toggle: function() {
            if (this.isFolder) {
                this.isOpen = !this.isOpen;
            }
        },
    }
}
</script>

<style scoped>
    li {
        list-style: none;
    }
</style>